import { render, staticRenderFns } from "./ConfigurationSidebar.vue?vue&type=template&id=669b61e2&scoped=true&"
import script from "./ConfigurationSidebar.vue?vue&type=script&lang=js&"
export * from "./ConfigurationSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationSidebar.vue?vue&type=style&index=0&id=669b61e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669b61e2",
  null
  
)

export default component.exports